import React from "react"
import {
    getAdminDetails,
    GetAdminDetailsResponse,
    getUserDetails,
    GetUserDetailsResponse,
    UserQuery,
} from "../../../../users/userApi"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { UserDetailsContent } from "./UserDetailsContent"
import { UserDetailsDialogProps } from "./UserDetailsDialog"

function transformAdminData(data: GetAdminDetailsResponse) {
    return data.admin
}

function transformUserData(data: GetUserDetailsResponse) {
    return data.user
}

type DataLoaderProps = Pick<UserDetailsDialogProps, "userId" | "userType">

export function DataLoader({ userId, userType }: DataLoaderProps) {
    const adminResult = useApiQuery(getAdminDetails, {
        queryName: UserQuery.ADMIN_DETAILS,
        dependencies: {
            userId: userId,
        },
        enabled: userType === "admin",
        suspense: true,
        useErrorBoundary: true,
        select: transformAdminData,
    })

    const userResult = useApiQuery(getUserDetails, {
        queryName: "get-user-details",
        dependencies: {
            userId: userId,
        },
        enabled: userType === "user",
        suspense: true,
        useErrorBoundary: true,
        select: transformUserData,
    })

    const data = userType === "admin" ? adminResult.data : userResult.data

    return <UserDetailsContent user={data} />
}
